/* global $ */
var camerasMap = {}
var camerasCount = 0
var names = {}
var duplicates = {}
var hiddenCamerasMap = {}
var walkCameras = function (items, parentText, deduplication) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i]
    var id = item.id
    var text = parentText ? parentText + '_' + item.text : item.text
    if (item.id.indexOf('c_') === 0) {
      item.icon = '/static/images/tree_c.png'
      if (deduplication !== false) {
        var representId = names[text]
        if (representId) {
          if (duplicates[representId]) {
            duplicates[representId].push(id)
          } else {
            duplicates[representId] = [id]
          }
          hiddenCamerasMap[id] = item
          items.splice(i, 1)
          i--
        } else {
          names[text] = id
          camerasMap[id] = item
          camerasCount++
        }
      } else {
        camerasMap[id] = item
        camerasCount++
      }
    } else {
      item.icon = '/static/images/tree_o.png'
      if (item.children && item.children.length > 0) {
        walkCameras(item.children, text, deduplication)
      }
    }
  }
}
if (window.$camerasTree) {
  walkCameras(window.$camerasTree.children)
  names = null
}
module.exports = {
  walkCameras: function () {
    camerasCount = 0
    walkCameras.apply(this, arguments)
  },
  getCameraName: function (id) {
    var camera = camerasMap[id]
    if (camera) {
      return camera.text
    } else if (hiddenCamerasMap[id]) {
      return hiddenCamerasMap[id].text
    } else {
      return null
    }
  },
  getCamera: function (id) {
    return camerasMap[id] || hiddenCamerasMap[id]
  },
  getCameras: function (ids) {
    var cameras = []
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i]
      if (camerasMap[id]) {
        cameras.push(ids[i])
      }
    }
    return cameras
  },
  countCameras: function () {
    return camerasCount
  },
  filterCameras: function (filter) {
    var cameras = []
    for (var id in camerasMap) {
      var camera = camerasMap[id]
      if (!filter || filter(camera)) {
        cameras.push(camera)
      }
    }
    return cameras
  },
  filterCameraIds: function (filter) {
    var cameraIds = []
    for (var id in camerasMap) {
      var camera = camerasMap[id]
      if (!filter || filter(camera)) {
        cameraIds.push(camera.id)
      }
    }
    return cameraIds
  },
  getDuplicateCameraIds: function (id) {
    return duplicates[id]
  },
  validatePlateNumber: function (rule, value, callback) {
    if (!value || value === '') {
      callback(new Error('请输入车牌号'))
    } else if (value.trim().replace(/\*|\?/g, '').length === 0) { // 车牌号必选
      callback(new Error('输入的车牌号中不能只包含通配符'))
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]{1,}$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'))
    } else {
      callback()
    }
  },
  validateOptionalPlateNumber: function (rule, value, callback) { // 车牌号可选
    if (!value || value === '') {
      callback()
    } else if (value.trim().replace(/\*|\?/g, '').length === 0) {
      callback(new Error('输入的车牌号中不能只包含通配符'))
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]*$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'))
    } else {
      callback()
    }
  },
  validateRealPlateNumber: function (rule, value, callback) { // 完整车牌号
    if (!value || value === '') {
      callback(new Error('请输入准确的车牌'))
    } else if (value.trim().indexOf('*') !== -1 || value.trim().indexOf('?') !== -1) {
      callback(new Error('输入的车牌号中不能包含通配符'))
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]*$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'))
    } else if (value.trim().length !== 7 && value.trim().length !== 8) {
      callback(new Error('车牌号长度应为7或8个字符'))
    } else {
      callback()
    }
  },
  validateTimeArea: function (rule, value, callback) {
    if (Array.isArray(value) && value.length > 1 && value[0] && value[1]) {
      callback()
    } else {
      callback(new Error('请选择时间范围'))
    }
  },
  mapLocalization: function (Leaflet) {
    Leaflet.drawLocal.draw.toolbar.buttons.polygon = '画多边形'
    Leaflet.drawLocal.draw.toolbar.buttons.circle = '画圆形'
    Leaflet.drawLocal.draw.toolbar.buttons.rectangle = '画矩形'
    Leaflet.drawLocal.draw.toolbar.buttons.sector = '画扇形'
    Leaflet.drawLocal.draw.toolbar.actions.title = '取消'
    Leaflet.drawLocal.draw.toolbar.actions.text = '取消'
    Leaflet.drawLocal.draw.toolbar.finish.title = '完成'
    Leaflet.drawLocal.draw.toolbar.finish.text = '完成'
    Leaflet.drawLocal.draw.toolbar.undo.title = '删除最后一个点'
    Leaflet.drawLocal.draw.toolbar.undo.text = '删除最后一个点'

    Leaflet.drawLocal.draw.handlers.simpleshape.tooltip.end = '松开鼠标结束'
    Leaflet.drawLocal.draw.handlers.rectangle.tooltip.start = '点击并拖拽，画出一个矩形'
    Leaflet.drawLocal.draw.handlers.sector.tooltip.start = '点击并拖拽，画出一个扇形'
    Leaflet.drawLocal.draw.handlers.sector.radius = '半径'
    Leaflet.drawLocal.draw.handlers.circle.tooltip.start = '点击并拖拽，画出一个圆形'
    Leaflet.drawLocal.draw.handlers.circle.radius = '半径'
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.start = '点击鼠标，开始绘制多边形'
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.cont = '点击鼠标，继续绘制多边形'
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.end = '点击第一个点，完成绘制'

    Leaflet.drawLocal.edit.toolbar.actions.save.title = '保存更改'
    Leaflet.drawLocal.edit.toolbar.actions.save.text = '保存'
    Leaflet.drawLocal.edit.toolbar.actions.cancel.title = '取消编辑，放弃所有更改'
    Leaflet.drawLocal.edit.toolbar.actions.cancel.text = '取消'
    Leaflet.drawLocal.edit.toolbar.actions.clearAll.title = '清除所有图形'
    Leaflet.drawLocal.edit.toolbar.actions.clearAll.text = '清空'

    Leaflet.drawLocal.edit.toolbar.buttons.edit = '编辑图形'
    Leaflet.drawLocal.edit.toolbar.buttons.editDisabled = '没有图形可编辑'
    Leaflet.drawLocal.edit.toolbar.buttons.remove = '删除图形'
    Leaflet.drawLocal.edit.toolbar.buttons.removeDisabled = '没有图形可删除'

    Leaflet.drawLocal.edit.handlers.edit.tooltip.text = '拖动图形上的控制点进行编辑'
    Leaflet.drawLocal.edit.handlers.edit.tooltip.subtext = '点击取消可撤销更改'
    Leaflet.drawLocal.edit.handlers.remove.tooltip.text = '点击要删除的图形'
  },
  toLogin: function () {
    location.href = '/login.html'
  },
  toHome: function () {
    location.href = '/index.html'
  },
  toGuide: function () {
    location.href = '/guide.html'
  },
  pickerOptions: {
    shortcuts: [{
      text: '最近1天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近7天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '最近30天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }]
  },
  pickerOptions2: {
    shortcuts: [{
      text: '今后1天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '今后7天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    }, {
      text: '今后30天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    }]
  },
  pickerOptions3: {
    shortcuts: [{
      text: '截止今天',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        end.setHours(23)
        end.setMinutes(59)
        end.setSeconds(59)
        picker.$emit('pick', [start, end])
      }
    }]
  },
  autoDraw: function (selector) {
    setTimeout(function () {
      var element = $(selector)[0]
      element.click()
    }, 200)
  },
  getMovingDurations (latlngs, speed) {
    speed = speed || 1
    let durations = []
    for (let i = 0, j = latlngs.length - 1; i < j; i++) {
      let distance = latlngs[i].distanceTo(latlngs[i + 1])
      if (distance > 20000) {
        durations[i] = 2000 * speed
      } else if (distance > 10000 && distance <= 20000) {
        durations[i] = 1600 * speed
      } else if (distance > 5000 && distance <= 10000) {
        durations[i] = 1200 * speed
      } else if (distance === 0) {
        durations[i] = 0
      } else {
        durations[i] = 800 * speed
      }
    }
    return durations
  },
  vehicleKinds: {
    轿车: '轿车',
    商务车: '商务车',
    越野车: '越野车',
    皮卡车: '皮卡车',
    面包车: '面包车',
    小型客车: '小型客车',
    大型客车: '大型客车',
    小型货车: '小型货车',
    大型货车: '大型货车',
    重型货车: '重型货车',
    栏板卡车: '栏板卡车',
    厢式货车: '厢式货车',
    市政车: '市政车',
    工程运输车: '工程运输车',
    微型轿车: '微型轿车',
    校车: '校车',
    其他: '其他'
  },
  plateColors: {
    蓝色: '蓝',
    黄色: '黄',
    绿色: '绿',
    白色: '白',
    黑色: '黑'
  },
  vehicleColors: {
    黑色: '黑色',
    白色: '白色',
    红色: '红色',
    绿色: '绿色',
    青色: '青色',
    蓝色: '蓝色',
    黄色: '黄色',
    紫色: '紫色',
    深灰色: '深灰色',
    银灰色: '银灰色',
    棕色: '棕色',
    香槟金色: '香槟金色',
    粉色: '粉色',
    橙色: '橙色',
    其他: '其他'
  },
  cycleColors: {
    黑: '黑',
    白: '白',
    灰: '灰',
    红: '红',
    蓝: '蓝',
    黄: '黄',
    橙: '橙',
    棕: '棕',
    绿: '绿',
    紫: '紫',
    青: '青',
    粉: '粉',
    其他: '其他'
  },
  commonColors: {
    黑: '黑',
    白: '白',
    灰: '灰',
    红: '红',
    蓝: '蓝',
    黄: '黄',
    橙: '橙',
    棕: '棕',
    绿: '绿',
    紫: '紫',
    青: '青',
    粉: '粉',
    拼接色: '拼接色',
    混色: '混色',
    其他: '其他'
  },
  dressUpStyle: {
    长袖: '长袖',
    短袖: '短袖',
    其他: '其他'
  },
  dressDownStyle: {
    长裤: '长裤',
    短裤: '短裤',
    裙子: '裙子',
    其他: '其他'
  },
  commonStates: {
    true: '是',
    false: '否'
  },
  numberCyclists: {
    一人: '一人',
    两人: '两人',
    多人: '多人'
  },
  isHair: {
    有头发: '有头发',
    头发较少: '头发较少',
    不确定: '不确定'
  },
  captureAngles: {
    0: '电警',
    1: '卡口'
  },
  cycleTypes: {
    batterybike: '电动自行车',
    batterymotor: '电动摩托车',
    bike: '自行车',
    motorbike_withBumper: '摩托车-带保险杠',
    motorbike_withoutBumper: '摩托车-无保险杠',
    motor_light: '摩托车-轻型',
    // pedestrian: '行人',
    pedicab_withHood: '三轮车-有篷',
    pedicab_withoutHood: '三轮车-无篷',
    tail_bike: '自行车车尾',
    tail_motor_batterycar: '摩托车、电动车车尾',
    tail_tricycle: '三轮车车尾',
    three_wheeled_scooter: '三轮摩托车',
    car_head: '车头',
    car_tail: '车尾',
    nonveh_side: '非机动车-侧身',
    others: '其他'
  },
  pedestrianAgeLimits: {
    '少年': '少年',
    '青年': '青年',
    '中年': '中年',
    '老年': '老年',
    '其他': '其他'
  },
  pedestrianGenders: {
    '男': '男',
    '女': '女'
  },
  videoTaskAlgorithm: [{
    label: '车辆分析',
    value: '0',
    disabled: false,
    icon: 'icon-vehicle'
  }, {
    label: '非机动车分析',
    value: '1',
    disabled: false,
    icon: 'icon-zixingche'
  }, {
    label: '行人属性分析',
    value: '2',
    disabled: false,
    icon: 'icon-pedestrian'
  }
  // , {
  //   label: '拥堵判别',
  //   value: '3',
  //   disabled: false,
  //   icon: 'icon-congestion'
  // }
  // {
  //   label: '警戒区域',
  //   value: '4',
  //   disabled: false,
  //   icon: 'icon-warningArea'
  // },
  // {
  //   label: '人脸检测',
  //   value: '5',
  //   disabled: false,
  //   icon: 'icon-face'
  // }
  ],
  searchModes: {
    '0': '文本检索',
    '1': '图像检索'
  },
  getTaskAlgorithmLabel (name, result, data) {
    data = data || this.videoTaskAlgorithm
    result = result || []
    for (let i = 0, j = data.length; i < j; i++) {
      let item = data[i]
      if (item.value === name) {
        return result.concat(item.label)
      } else if (item.children) {
        var values = this.getTaskAlgorithmLabel(name, result.concat(item.label), item.children)
        if (values.length > 0) {
          return values
        }
      }
    }
    return []
  },
  getTaskAlgorithmIcon (name, result, data) {
    data = data || this.videoTaskAlgorithm
    result = result || []
    for (let i = 0, j = data.length; i < j; i++) {
      let item = data[i]
      if (item.value === name) {
        return result.concat(item.icon)
      }
    }
    return []
  }
}



// WEBPACK FOOTER //
// ./src/utils/commons.js